import { render, staticRenderFns } from "./PageSimplifiedView.vue?vue&type=template&id=08a6d5d0&scoped=true"
import script from "./PageSimplifiedView.vue?vue&type=script&lang=js"
export * from "./PageSimplifiedView.vue?vue&type=script&lang=js"
import style0 from "./PageSimplifiedView.vue?vue&type=style&index=0&id=08a6d5d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08a6d5d0",
  null
  
)

export default component.exports